import { render, staticRenderFns } from "./Preset.vue?vue&type=template&id=25d7f095&scoped=true&"
import script from "./Preset.vue?vue&type=script&lang=js&"
export * from "./Preset.vue?vue&type=script&lang=js&"
import style0 from "./Preset.vue?vue&type=style&index=0&id=25d7f095&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d7f095",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
